import React, { useState } from "react";
import { FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";
import { SiLeetcode } from "react-icons/si";
import Navbar from "./Navbar";
import { trackEvent } from "../utils/analytics";

const Header = () => {
  const [navOpen, setNavOpen] = useState(false);

  const toggleNav = () => {
    setNavOpen(!navOpen);
  };

  return (
    <header className="fixed top-0 left-0 w-full h-20 flex items-center z-40 bg-gradient-to-b from-zinc-900 to-zinc-90/0">
      <div className="max-w-screen-2xl w-full mx-auto px-4 flex justify-between items-center md:px-6 md:grid md:grid-cols-[1fr,3fr,1fr]">
        <h1 className="text-2xl font-bold text-zinc-50">perkyPearl</h1>

        <div className="relative md:justify-self-center">
          <button className="menu-btn md:hidden" onClick={toggleNav}>
            <span className="material-symbols-rounded">
              {navOpen ? "close" : "menu"}
            </span>
          </button>

          <Navbar navOpen={navOpen} />
        </div>

        <div className="hidden md:flex space-x-4 items-center justify-self-end ">
          <a
            href="https://github.com/perkypearl"
            target="_blank"
            rel="noopener noreferrer"
            className="text-zinc-50 hover:text-gray-400 transition duration-300"
            onClick={() => trackEvent("github_profile_click", { link_url: "https://github.com/perkypearl", link_type: "social" })}
          >
            <FaGithub size={24} />
          </a>
          <a
            href="https://www.linkedin.com/in/perkypearl/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-zinc-50 hover:text-[#0e76a8] transition duration-300"
            onClick={() => trackEvent("linkedin_profile_click", { link_url: "https://www.linkedin.com/in/perkypearl/", link_type: "social" })}
          >
            <FaLinkedin size={24} />
          </a>
          <a
            href="https://leetcode.com/u/perkyPearl/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-zinc-50 hover:text-[#FFA116] transition duration-300"
            onClick={() => trackEvent("certification_click", { link_url: "https://leetcode.com/u/perkyPearl/", link_type: "certification" })}
          >
            <SiLeetcode size={24} />
          </a>
          <a
            href="https://www.instagram.com/precisepearl/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-zinc-50 hover:text-[#C13584] transition duration-300"
          >
            <FaInstagram size={24} />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;